export default "__VITE_ASSET__SxHXy06J__"